import { render, staticRenderFns } from "./CruiseReviewItem.vue?vue&type=template&id=4fa4b4ed&scoped=true"
import script from "./CruiseReviewItem.vue?vue&type=script&lang=js"
export * from "./CruiseReviewItem.vue?vue&type=script&lang=js"
import style0 from "./CruiseReviewItem.vue?vue&type=style&index=0&id=4fa4b4ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4b4ed",
  null
  
)

export default component.exports